import { apiClient } from './apiClient';

export type FilingType = {
  id: number;
  name: string;
};

export function getFilingTypes(): Promise<FilingType[]> {
  return apiClient.get('/filing-types', {});
}
